import React from 'react'

import { AnalyticsProductLabel } from '../../../../analyticsModule/components/AnalyticsProductLabel/AnalyticsProductLabel'
import { useAnalyticsCardBase } from '../../../../hooks/useAnalyticsCardBase'
import type { StatsReportCardProps } from '../../AnalyticsDashboard.types'
import { createStatsData } from '../../utils/createStatsData'

const reportId = 'top_products_by_units_sold'

type TopProductsByUnitsSoldRow = {
  product: string
  units_sold: number
  metadata?: {
    status?: string
    offerId?: string
  }
}

export const useTopProductsByUnitsSoldReportCard = (): StatsReportCardProps => {
  const analyticsCardBase = useAnalyticsCardBase({ reportId })

  const data = createStatsData<TopProductsByUnitsSoldRow>({
    rows: analyticsCardBase.reportData?.report?.rows,
    mapFn: (row) => ({
      label: (
        <AnalyticsProductLabel
          name={row.product}
          status={row.metadata?.status}
          productId={row.metadata?.offerId}
        />
      ),
      value: row.units_sold,
    }),
  })

  return {
    ...analyticsCardBase,
    type: 'stats',
    data,
    header: {
      ...analyticsCardBase.header,
      label: 'Top products by units sold',
      tooltip: {
        title: 'Top products by units sold',
        description: 'Products ranked by how many units were sold.',
      },
    },
  }
}
